module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item",
    attrs: {
      "id": "product.spu.id"
    }
  }, [_c('div', {
    staticClass: "img-box"
  }, [_c('img', {
    attrs: {
      "src": _vm.product.spu.sku_info[0].ali_image,
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('h6', {
    staticClass: "ellipsis"
  }, [_vm._v(_vm._s(_vm.product.spu.sku_info[0].title))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.product.spu.sku_info[0].sub_title))])]), _vm._v(" "), _c('p', {
    staticClass: "price"
  }, [_c('i', [_vm._v("¥")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.product.spu.price))])]), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "dot-list"
  }, [_c('li')])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-50f5bdcb","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/product.vue
// module id = 355
// module chunks = 4 7